import { lazyWithRetry } from "utils/lazy-with-retry";
import { IGaiaObjectsProps } from "./definitions"; // import the correct type

const LazyGaiaObjects = lazyWithRetry(() => import("./GaiaObjects"));

const GaiaObjects = (props: IGaiaObjectsProps) => (
  <LazyGaiaObjects {...props} />
);

export default GaiaObjects;
